// Feature flags for tab switch optimization
export const FEATURES = {
  // Phase 2: Remove dynamic keys
  USE_STABLE_KEYS: true,  // ✅ ENABLED - Phase 2 activated

  // Phase 3: Message caching
  ENABLE_MESSAGE_CACHE: true,  // ✅ ENABLED - Phase 3 activated
  MESSAGE_CACHE_TTL: 60 * 60 * 1000,  // 1 hour

  // Phase 4: Optimize refetch
  OPTIMIZE_CONVERSATION_SWITCH: true,  // ✅ ENABLED - Phase 4 activated
};
